// ONE LOOK FOR EVERY LOCKED FIELD IN THE INVOICE MODAL (owner item 2,
// 2026-08-28): a locked value is the same shaded `readOnly` + `filled-darker`
// box as the header panel's. Off where the table offers no control at all —
// the expanded queue card, which is a gallery, not a form.
//
// Its own file since D-425 (owner, 2026-10-28), when the Additional Detail
// pop-up and its Associated Entities section began drawing their read-only
// values as these boxes too ("no text over gray background but instead input
// field blocks like we have for every other field"); the line table and the
// group row draw theirs with it as before.
import { Input, makeStyles, mergeClasses } from '@fluentui/react-components'
import { useMoneyInputStyles, useNumberInputStyles } from '../lib/theme'

const useStyles = makeStyles({
  // A box fills its cell and may shrink inside a fixed-layout table: Fluent's
  // `Input` ships `min-width: 160px`, which would set the numeric columns' floor.
  cellInput: { width: '100%', minWidth: 0 },
  // ONE LINE, CLIPPED (owner, 2026-11-04 — D-471): an unboxed value — every
  // field on the queue card's rows — stays on one line and ends in an ellipsis
  // rather than wrapping; the full text is on hover.
  oneLine: { display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
})

export function LockedValue({
  boxed,
  value,
  align,
  ariaLabel,
  className,
  title,
}: {
  boxed: boolean
  value: string
  align?: 'money' | 'number'
  ariaLabel?: string
  /** Extra classes for the box, e.g. the red border a group's locked field takes (D-406). */
  className?: string
  /** Hover text in place of the value, e.g. the flags a yellow box stands for (D-417). */
  title?: string
}) {
  const s = useStyles()
  const ms = useMoneyInputStyles()
  const ns = useNumberInputStyles()
  if (!boxed) {
    return (
      <span className={s.oneLine} title={title ?? value}>
        {value}
      </span>
    )
  }
  return (
    <Input
      className={mergeClasses(s.cellInput, className)}
      size="small"
      readOnly
      appearance="filled-darker"
      value={value}
      // The full text stays reachable on hover; a description often outruns its column.
      title={title ?? value}
      aria-label={ariaLabel}
      input={align === 'money' ? { className: ms.moneyText } : align === 'number' ? { className: ns.numText } : undefined}
    />
  )
}
